module.exports = __webpack_public_path__ + "img/ardiNewlogoEN.cc7170ef.svg";